import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;

  padding: 3rem 4rem;

  background-color: #ffffff;
  border: 10px solid ${({ themeMasterColor }) => themeMasterColor};
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-weight: 500;
    font-size: 2rem;

    margin-bottom: 0.5rem;
  }

  height: 700px;
  max-width: 1200px;

  @page {
    size: 1200px 700px;
  }

  ${({ courseTitleLength }) =>
    courseTitleLength > 30 &&
    css`
      height: 750px;

      @page {
        size: 1200px 750px;
      }
    `}

  @media (min-width: 1024px) and (max-width: 1599px) {
    height: auto;

    padding: 2rem 3rem;
  }
`;

export const Brand = styled.div`
  margin-bottom: 5rem;

  img {
    height: 3rem;
  }

  @media (min-width: 1024px) and (max-width: 1599px) {
    img {
      height: 2rem;
    }
  }
`;

export const Header = styled.header`
  @media (min-width: 1024px) and (max-width: 1599px) {
    h1 {
      font-size: 0.9rem !important;
    }

    p {
      font-size: 1.5rem !important;
      width: calc(100% - 70px) !important;
    }
  }

  h1 {
    font-size: 1.5rem;
  }

  p {
    color: ${({ themeMasterColor }) => themeMasterColor};

    font-style: normal;
    font-weight: bold;

    font-size: 2.8rem;

    padding-right: 4rem;
    width: calc(100% + 65px);
    max-width: calc(100% + 65px);

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const Body = styled.div`
  @media (min-width: 1024px) and (max-width: 1599px) {
    h1 {
      font-size: 0.9rem !important;
    }

    p {
      font-size: 1.5rem !important;
    }

    span {
      font-size: 0.8rem !important;
    }
  }

  h1 {
    font-size: 1.5rem;
  }

  p {
    color: #130c25;

    font-style: normal;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  span {
    color: #130c25;

    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  width: 100%;
  margin-top: 2.5rem;

  p {
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;

    margin-bottom: 0.3rem;
  }

  .signature-image {
    height: 3.5rem;
  }

  @media (min-width: 1024px) and (max-width: 1599px) {
    .signature-image {
      height: 2rem;
    }

    p,
    span {
      font-size: 0.7rem !important;
    }
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;

  position: absolute;
  top: -1px;
  right: 3rem;

  width: 200px;
  height: 250px;

  background-color: ${({ themeMasterColor }) => themeMasterColor || "#0073e5"};

  & > div {
    text-align: center;
    width: 100%;
    padding: 2rem;
    color: #ffffff;
  }

  img {
    width: 100%;
  }

  small {
    float: right;
  }

  @media (min-width: 1024px) and (max-width: 1599px) {
    right: 1rem;

    width: 150px;
    height: 150px;

    small {
      font-size: 0.5rem;
    }
  }
`;

export const Polygon = styled.div`
  position: absolute;
  top: 15.5rem;
  right: 3rem;

  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-top: 75px solid ${({ themeMasterColor }) => themeMasterColor};

  @media (min-width: 1024px) and (max-width: 1599px) {
    top: 9.3rem;
    right: 1rem;

    border-left: 75px solid transparent;
    border-right: 75px solid transparent;
    border-top: 50px solid ${({ themeMasterColor }) => themeMasterColor};
  }
`;

export const ContentQRCode = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  color: #898692;

  p {
    font-size: 0.8rem;
  }

  .header-content {
    margin-top: 0.8rem;
  }

  @media (min-width: 1024px) and (max-width: 1599px) {
    p {
      font-size: 0.6rem !important;
    }

    .header-content {
      margin-top: 0.4rem;
    }

    small {
      font-size: 0.5rem !important;
    }
  }
`;
